export default {
    faqList: [],
    faqListCount: 0,
    faq: {}
}